/* DON'T EDIT THIS FILE: edit original and run build again */ export const jdLabel = "John Deere Credit Cía. Financiera SA";
